const modules = {
    "[data-mobile-navigation]": () => import("./modules/mobileNavigation"),
    "[data-content-tabs]": () => import("./modules/tabs"),
    // '[data-splide-carousel]': () => import('./modules/carousel'),
    "[data-modal-target]": () => import("./modules/modal"),
    "[data-swiper]": () => import("./modules/swiper"),
    // '[data-video-select]': () => import('./modules/videoSelect'),
    "[data-video]": () => import("./modules/videoBackground"),
    // '[data-video-background]': () => import('./modules/video.js'),
    "[data-slider]": () => import("./modules/slider.js"),
    "[data-reveal]": () => import("./modules/reveal.js"),
    "[data-accordion]": () => import("./modules/accordion"),
    "[data-graphic]": () => import("./modules/transitions/graphic"),
    "[data-img-accordion]": () => import("./modules/imgAccordion"),
    "[data-lightbox-toggle]": () => import("./modules/lightbox"),
    "[data-projects]": () => import("./modules/projects"),
    "[data-projects-mobile]": () => import("./modules/projectsMobile"),
    "[data-transcript]": () => import("./modules/transcript"),
    "[data-social-share]": () => import("./modules/socialShare"),
    "[data-mobile-topics]": () => import("./modules/mobileTopics"),
    "[data-pin-content]": () => import("./modules/pins"),
    "[data-fade-pins]": () => import("./modules/fadePins"),
    "[data-column-pin]": () => import("./modules/columnPin"),
    "[data-swiper-carousel]": () => import("./modules/swiperCarousel"),
    "[data-lottie]": () => import("./modules/lottie"),
    "[data-lite-yt-embed]": () => import("./modules/liteYouTube"),
};

export default (scope) => {
    Object.keys(modules).forEach((selector) => {
        const request = modules[selector];

        ((els) => {
            if (els && els.length) {
                request().then(({ default: module }) => module(els));
            }
        })(scope.querySelectorAll(selector));
    });
};
